/** ebooking：仅 hy_dir_partner.zhilian_type=3（直签自营）可维护酒店/房型 */
export default {
  computed: {
    canMaintainHotel() {
      const u = this.userInfo || {};
      if (
        u.can_maintain_hotel !== undefined &&
        u.can_maintain_hotel !== null &&
        u.can_maintain_hotel !== ""
      ) {
        return Number(u.can_maintain_hotel) === 1;
      }
      return Number(u.zhilian_type) === 3;
    },
  },
  methods: {
    assertCanMaintain(actionLabel) {
      if (this.canMaintainHotel) {
        return true;
      }
      this.$message.warning(
        actionLabel || "当前账号仅可查看，不可修改酒店、房型、政策或房价房态"
      );
      return false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/supplierMaintain.js